var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.countries.length && _vm.basins.length)?_c('div',{staticClass:"h-100"},[_c('Header'),(_vm.assessment.step == _vm.steps[0])?_c('Home'):_c('Main')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }